import { useState } from "react"
import { OpenFoodFactEntry } from "model/food/types"
import {
  updateManualNutritionMealWhenPortionChange,
  updateNonIngredientEntryNutritionWhenPortionChange,
} from "features/food/helper/edamaForm"

const useOpenFoodFactForm = <T extends OpenFoodFactEntry>(edama: T) => {
  const [food, setFood] = useState<T>(edama)

  const onPortionChange = (portion: number) => {
    const nutrition = food.isManualNutrition
      ? updateManualNutritionMealWhenPortionChange(food, portion)
      : updateNonIngredientEntryNutritionWhenPortionChange(food, portion)

    setFood({
      ...food,
      ...nutrition,
      portion,
    })
  }

  const updateFoodAsManualNutrition = ({
    gram,
    ...nutrition
  }: Partial<OpenFoodFactEntry>) => {
    if (food) {
      setFood({ ...food, ...nutrition, isManualNutrition: true })
    }
  }

  return {
    openFoodFact: food,
    setEdama: setFood,
    onPortionChange,
    updateFoodAsManualNutrition,
  }
}

export default useOpenFoodFactForm
